var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fi",class:{ [`flaticon-${_vm.glyph}`]: true },attrs:{"title":_vm.title||false,"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }